



























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import WordIcon from '@/components/icons/WordIcon.vue';
import ExcelIcon from '@/components/icons/ExcelIcon.vue';
import PdfIcon from '@/components/icons/PdfIcon.vue';
import PowerPointIcon from '@/components/icons/PowerPointIcon.vue';
import FileIcon from '@/components/icons/FileIcon.vue';
import DeleteIcon from '@/components/icons/DeleteIcon.vue';
import Checkbox from '@/components/common/inputs/Checkbox.vue';
import { Attachment, AttachmentFile } from '@/store/modules/processInterfaces';

@Component({
  components: {
    WordIcon,
    ExcelIcon,
    PdfIcon,
    PowerPointIcon,
    FileIcon,
    DeleteIcon,
    Checkbox
  }
})
export default class AttachmentComponent extends Vue {
  @Prop(Object)
  attachment!: AttachmentFile;
  @Prop(Boolean)
  disabled!: boolean;
  @Prop(Boolean)
  isUploading!: boolean;
  @Prop(Boolean)
  canChangeVisibility!: boolean;

  maxAttachmentSize = 10000000;

  get isAttachmentToLarge() {
    return this.attachment.file ? this.attachment.file.size > this.maxAttachmentSize : false;
  }

  get type() {
    const word = ['.doc', '.dot', '.wbk', '.docx', '.docm', '.dotx', '.dotm', '.docb'];
    const excel = ['.xls', '.xlt', '.xlm', '.xlsx', '.xlsm', '.xltx', '.xltm'];
    const powerPoint = [
      '.ppt',
      '.pot',
      '.pps',
      '.pptx',
      '.pptm',
      '.potx',
      '.potm',
      '.ppam',
      '.ppsx',
      '.ppsm',
      '.sldx',
      '.sldm'
    ];

    if (this.attachment.fileName.endsWith('.pdf')) {
      return 'pdf';
    }

    if (word.some(extension => this.attachment.fileName.endsWith(extension))) {
      return 'word';
    }

    if (excel.some(extension => this.attachment.fileName.endsWith(extension))) {
      return 'excel';
    }

    if (powerPoint.some(extension => this.attachment.fileName.endsWith(extension))) {
      return 'powerPoint';
    }

    return 'other';
  }
}
